
export enum PaymentType {
  Online = 'Online',
  OnDelivery = 'OnDelivery',
}
